module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mode":"Frequency","daily":"Daily","weekly":"Weekly"},"fr":{"mode":"Périodicité","daily":"Journalier","weekly":"Hebdomadaire"},"de":{"mode":"Periodizität","daily":"Täglich","weekly":"Wöchentlich"}}')
  delete Component.options._Ctor
}
